import { Button, Modal, ModalBody, ModalHeader } from "reactstrap"
import ButtonLoader from "./ButtonLoader"
import * as React from "react"
import { SyntheticEvent } from "react"
import { observer } from "mobx-react"
import { observable } from "mobx"
import AppStateStore from "../stores/AppStateStore"
import ApiClient, { ApiRoutes } from "../api/ApiClient"
import { toast } from "react-toastify"
import { route } from "../routes/routes"
import Util, { formatCurrency } from "../common/Util"
import CategoryChangeRequest from '../models/CategoryChangeRequest'

type ApproveCategoryChangeApplicationModalProps = {
  isOpen: boolean
  toggle: () => void
} & ApproveCategoryChangeApplicationFormProps

@observer
export class ApproveCategoryChangeApplicationModal extends React.Component<ApproveCategoryChangeApplicationModalProps> {
  render (): React.ReactNode {
    const { isOpen, toggle, ...rest } = this.props

    return <Modal isOpen={isOpen} onClosed={this.props.onCancel} size="md">
      <ModalHeader toggle={toggle}>
        Approve Application
      </ModalHeader>
      <ModalBody>
        <ApproveApplicationForm
          {...rest}
        />
      </ModalBody>
    </Modal>
  }
}

type ApproveCategoryChangeApplicationFormProps = {
  onCancel: () => void
  onSaved: (memberId: number) => void
  categoryChangeRequest: CategoryChangeRequest
}

@observer
export class ApproveApplicationForm extends React.Component<ApproveCategoryChangeApplicationFormProps> {
  @observable private submitting = false

  private onSubmit = (ev: SyntheticEvent) => {
    ev.preventDefault()

    this.submitting = true
    AppStateStore.showModalSpinner()

    ApiClient.getInstance()
      .post(route(ApiRoutes.categoryChangeRequests.approve, { id: this.props.categoryChangeRequest.id }))
      .then(response => {
        toast.success('Category Change Approved')
        this.props.onSaved(this.props.categoryChangeRequest!.memberId)
      })
      .catch(error => Util.handleErrorResponse(error.response, null, undefined, (response, message) => {
          AppStateStore.showAlertModal('Error', message, m => {
            m.hide()
          })
          return true
        })
      )
      .then(() => {
        AppStateStore.dismissModalSpinner()
        this.submitting = false
      })
  }

  render (): React.ReactNode {
    const { categoryChangeRequest } = this.props

    return <>
      <form onSubmit={this.onSubmit}>
        <div className="form-row">
          <div className="col-sm-12">
            <div className="form-group">
              <p>
                Are you sure you want to approve this category change?
                Their primary business category will be updated and their payment method will be charged {formatCurrency(categoryChangeRequest!.getCategoryChangeFeeTotal())}.
                The member will receive an email notification.
              </p>
            </div>
          </div>
        </div>

        <div className="form-buttons">
          <Button color="secondary" onClick={() => this.props.onCancel()}>Cancel</Button>
          <ButtonLoader type="submit" color="primary" loading={this.submitting}>Approve Category Change</ButtonLoader>
        </div>
      </form>
    </>
  }
}
